import React, { FC, useState } from "react";
import { useSelector } from "react-redux";
import { useErrorBoundary } from "react-error-boundary";

import DashboardLayout from "../../layouts/Dashboard.layout";
import { Button } from "../../components/common";
import { useGetContactsQuery } from "../../store/services/contacts";
import { selectContacts } from "../../store/reducers/contacts";
import { ContactsTable } from "../../components/tables/ContactsTable";
import { NewContactModal } from "../../components/modals/newContactModal";
import { ContactListEmptyState } from "../../components/banners";

export const ContactList: FC = () => {
  const { isError, error, refetch } = useGetContactsQuery();
  const data = useSelector(selectContacts);
  const [showNewContactForm, setShowNewContactForm] = useState(false);
  const handleInviteNew = () => setShowNewContactForm(true);
  const { showBoundary } = useErrorBoundary();

  if (isError) {
    showBoundary(error);
  }

  const InviteNewBtn = (
    <Button
      className="w-full md:w-auto"
      data-test="new-contact-btn"
      onClick={handleInviteNew}
      variant={Button.variant.TEMPTING}
    >
      Invite new
    </Button>
  );

  const ContactListContent =
    data && data.length ? (
      <ContactsTable data={data} reload={refetch} />
    ) : (
      <ContactListEmptyState onInviteNew={handleInviteNew} />
    );

  return (
    <>
      <DashboardLayout title="Contacts" action={InviteNewBtn}>
        {ContactListContent}
      </DashboardLayout>

      {showNewContactForm && (
        <NewContactModal
          isOpen={showNewContactForm}
          onClose={() => setShowNewContactForm(false)}
        />
      )}
    </>
  );
};
